module.exports = __webpack_public_path__ + "static/img/szafa_6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/szafa_6.jpg
// module id = 7WRH
// module chunks = 0